import { axiosInstance } from '../../../axios'

export const ClientSupportService = {
  fetchTicketTypes: async () => axiosInstance.get('api/web/v1/client/support/ticket_types'),
  fetchClientLocations: async () => axiosInstance.get('api/web/v1/client/support/client_locations'),
  postTicket: async (params) => axiosInstance.post('api/web/v1/client/support', params),
}
